import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Navigation, ChevronDown } from "lucide-react";
import { useLocation } from "@/context/LocationContext";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function LocationBar({ compact = false }) {
  const { loc, requestMyLocation, setPostcode } = useLocation();
  const [pc, setPc] = useState("");
  const [open, setOpen] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!pc.trim()) return;
    const l = await setPostcode(pc.trim());
    if (l) setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="location-bar-trigger"
          className="flex items-center gap-1.5 text-sm font-semibold text-[#1A3C2A] hover:text-[#E07A5F] transition-colors">
          <MapPin size={16} className="text-[#E07A5F]" />
          <span className="max-w-[140px] truncate">{loc?.label || "Set location"}</span>
          <ChevronDown size={14} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 rounded-2xl" align="start">
        <p className="font-display font-bold text-[#1A3C2A] mb-1">Your neighbourhood</p>
        <p className="text-xs text-[#5A626A] mb-3">Enter a UK postcode or area to see what's near you.</p>
        <form onSubmit={submit} className="flex gap-2 mb-2">
          <Input data-testid="location-postcode-input" value={pc} onChange={(e) => setPc(e.target.value)}
            placeholder="e.g. E8 3DL" className="rounded-xl" />
          <Button type="submit" data-testid="location-postcode-submit" className="rounded-xl bg-[#1A3C2A] hover:bg-[#132E20]">Go</Button>
        </form>
        <Button variant="outline" data-testid="location-use-mine"
          onClick={async () => { const l = await requestMyLocation(); if (l) setOpen(false); }}
          className="w-full rounded-xl border-[#E5DEC9] gap-2">
          <Navigation size={15} /> Use my current location
        </Button>
      </PopoverContent>
    </Popover>
  );
}
